module.exports = __webpack_public_path__ + "img/jujialei-4.6751e19a.png";